@if(isVisible) {
  <div id="disclaimer">
    <div class="w-full content-box mt-custom-8">
      <div id="close" (click)="isVisible  = false"></div>
      <div class="w-full text-center">
        <p><strong>You are about to gamble outside the jurisdiction of Alderney on MB Colossus products, whose gambling systems are not regulated or monitored by the Alderney Gambling Control Commission (AGCC).</strong></p>
        <p><strong>AGCC is not obligated to act upon any complaints received regarding such gambling.</strong></p>
      </div>
    </div>
  </div>
}
